<template>
    <div class="auth-page-root">
        <!-- Fond d'écran Blur inspiré de app.uska.fr -->
        <div id="background-blur">
            <div id="shape1"></div>
            <div id="shape2"></div>
            <div id="shape3"></div>
        </div>

        <div class="auth-container">
            <div class="row g-4 align-items-center justify-content-center w-100 m-0">
                <!-- Colonne Gauche : Présentation Uska Rebranding -->
                <div class="col-12 col-lg-6 col-xl-6 p-2 p-md-3">
                    <auth-presentation></auth-presentation>
                </div>

                <!-- Colonne Droite : Mot de passe oublié -->
                <div class="col-12 col-lg-5 col-xl-5 p-2 p-md-3">
                    <div class="auth-card">
                        <!-- En-tête -->
                        <div class="auth-card-header text-center mb-4">
                            <img src="/images/logo_uska_horizontal.svg" alt="Logo Uska" class="auth-form-logo mb-2" />
                            <h2 class="auth-title">Mot de passe oublié</h2>
                            <p class="auth-subtitle">Saisissez votre email pour réinitialiser votre mot de passe</p>
                        </div>

                        <!-- Formulaire -->
                        <form @submit.prevent="requestForgetPassword">
                            <div class="mb-3">
                                <label class="input-label" for="email">Adresse email</label>
                                <div class="modern-input-group">
                                    <v-icon class="input-icon-left">email</v-icon>
                                    <input
                                        v-model="email"
                                        type="email"
                                        id="email"
                                        name="email"
                                        placeholder="nom@destination.fr"
                                        class="custom-text-input"
                                        @keyup.enter="requestForgetPassword"
                                    />
                                </div>
                            </div>

                            <!-- Alerte confirmation -->
                            <v-alert
                                dense
                                text
                                type="success"
                                class="mt-3 mb-3 rounded-lg"
                                v-if="sent"
                            >
                                Un lien de réinitialisation de mot de passe a été envoyé à <b>{{ sentEmail }}</b>.
                            </v-alert>

                            <!-- Bouton Envoyer -->
                            <div class="mt-4">
                                <v-btn
                                    depressed
                                    block
                                    large
                                    color="primary"
                                    class="auth-submit-btn text-none"
                                    :disabled="!email || email === ''"
                                    @click="requestForgetPassword"
                                >
                                    <span>Envoyer le lien de réinitialisation</span>
                                    <v-icon right small>send</v-icon>
                                </v-btn>
                            </div>

                            <div class="mt-4 text-center">
                                <router-link to="/login" class="back-link">
                                    <v-icon x-small color="#2563eb" class="mr-1">arrow_back</v-icon>
                                    <span>Retour à la connexion</span>
                                </router-link>
                            </div>
                        </form>

                        <!-- Footer assistance -->
                        <div class="auth-card-footer mt-4 text-center">
                            <p class="mb-0 small text-muted">
                                Besoin d'assistance ?
                                <a href="https://www.uska.fr/contact" target="_blank" class="font-weight-semibold">
                                    Contactez notre support
                                </a>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AuthPresentation from "./auth/AuthPresentation.vue"

export default {
    name: "ForgetPassword",
    components: {
        AuthPresentation
    },
    data() {
        return {
            email: null,
            sentEmail: null,
            sent: false
        }
    },
    methods: {
        requestForgetPassword() {
            if (!this.email) return
            let payload = {
                email: this.email
            }

            this.$global.loading = true

            this.$http.post('auth/forget-password/request', payload).then(res => {
                this.$global.loading = false

                if (res.body.success) {
                    this.sentEmail = JSON.parse(JSON.stringify(this.email))
                    this.sent = true
                }
            }).catch(() => {
                this.$global.loading = false
            })
        }
    }
}
</script>

<style scoped>
.auth-page-root {
    min-height: 100vh;
    width: 100%;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 30px 15px;
    background-color: #f6f6f7;
    overflow-x: hidden;
}

#background-blur {
    height: 100vh;
    width: 100vw;
    position: fixed;
    top: 0;
    left: 0;
    background-color: #f6f6f7;
    overflow: hidden;
    z-index: 0;
}

#background-blur #shape1 {
    background-color: #a1d6e1;
    opacity: 0.55;
    filter: blur(140px);
    position: absolute;
    width: 80vh;
    height: 80vh;
    border-radius: 50%;
    bottom: -20%;
    right: -10%;
}

#background-blur #shape2 {
    width: 50vw;
    height: 65vh;
    background: #F8BA43;
    opacity: 0.38;
    filter: blur(140px);
    position: absolute;
    border-radius: 50%;
    top: -10%;
    left: -10%;
}

#background-blur #shape3 {
    width: 75vh;
    height: 75vh;
    background: #5ab7cb;
    opacity: 0.25;
    filter: blur(140px);
    position: absolute;
    border-radius: 50%;
    bottom: -20%;
    left: -15%;
}

.auth-container {
    position: relative;
    z-index: 2;
    max-width: 1180px;
    width: 100%;
}

.auth-card {
    background: rgba(255, 255, 255, 0.95);
    backdrop-filter: blur(20px);
    -webkit-backdrop-filter: blur(20px);
    border-radius: 28px;
    padding: 38px 32px;
    box-shadow: 0 20px 45px -10px rgba(15, 23, 42, 0.08), 0 0 0 1px rgba(255, 255, 255, 0.8);
}

.auth-form-logo {
    height: 84px;
    max-width: 320px;
    object-fit: contain;
}

.auth-title {
    font-size: 1.45rem;
    font-weight: 800;
    color: #0f172a;
    letter-spacing: -0.02em;
    margin-bottom: 4px;
}

.auth-subtitle {
    font-size: 0.86rem;
    color: #64748b;
    margin-bottom: 0;
}

.input-label {
    display: block;
    font-size: 0.82rem;
    font-weight: 600;
    color: #334155;
    margin-bottom: 6px;
}

.modern-input-group {
    display: flex;
    align-items: center;
    background-color: #f8fafc;
    border: 1.5px solid #e2e8f0;
    border-radius: 12px;
    padding: 0 14px;
    height: 48px;
    transition: all 0.2s ease;
}

.modern-input-group:focus-within {
    background-color: #ffffff;
    border-color: #2563eb;
    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.12);
}

.input-icon-left {
    color: #64748b !important;
    font-size: 20px !important;
    margin-right: 12px !important;
    flex-shrink: 0;
}

.custom-text-input {
    flex: 1;
    border: none !important;
    outline: none !important;
    background: transparent !important;
    font-size: 0.95rem;
    color: #0f172a;
    height: 100%;
    width: 100%;
}

.custom-text-input::placeholder {
    color: #94a3b8;
}

.auth-submit-btn {
    border-radius: 12px !important;
    font-weight: 700 !important;
    font-size: 0.95rem !important;
    letter-spacing: 0.01em !important;
    height: 46px !important;
    box-shadow: 0 4px 14px rgba(37, 99, 235, 0.25) !important;
}

.back-link {
    display: inline-flex;
    align-items: center;
    font-size: 0.86rem;
    font-weight: 600;
    color: #2563eb;
    text-decoration: none;
}

.back-link:hover {
    text-decoration: underline;
}

.auth-card-footer a {
    color: #2563eb;
    text-decoration: none;
}

.auth-card-footer a:hover {
    text-decoration: underline;
}
</style>